module.exports = __webpack_public_path__ + "static/media/floor-2-error.ceb12e45.jpg";